import { Select } from 'antd';
import { useGetInspectionVendorsQuery } from 'types/atlas-graphql';
interface InspectionVendorChooserProps {
  disabled: boolean;
  typeId?: string;
  // These optional parameters are passed in by the Form.Item wrapper
  id?: string;
  onChange?: (value: string, option: any) => void;
  value?: string;
  getPopupContainer?: (triggerNode: HTMLElement) => HTMLElement;
}

/** Using reduce to filter/map through the vendors - if/when more vendors are needed,
 * update the reduce accordingly or more (appropriately) update the API to send
 * only what is needed
 */
export function InspectionVendorChooser({
  disabled,
  typeId,
  id,
  onChange,
  value,
  getPopupContainer,
}: InspectionVendorChooserProps) {
  const filters = typeId ? [{ key: 'typeId', values: [typeId] }] : null;
  const { data, loading } = useGetInspectionVendorsQuery({
    variables: {
      filterBy: filters,
    },
  });
  const inspectionVendors = data?.inspectionVendors ?? [];

  const options = inspectionVendors.map(({ id, name }: { id: string; name: string }) => ({
    label: name,
    value: id,
  }));
  return (
    <Select
      data-testid="inspection-vendor-chooser"
      placeholder="Select a Vendor"
      options={options}
      loading={loading}
      disabled={disabled}
      value={value}
      onChange={onChange}
      id={id}
      getPopupContainer={getPopupContainer}
    />
  );
}
